module.exports = __webpack_public_path__ + "img/en-1.f1027441.png";